import React from 'react';

export default function Headshot(props){
  return(
    <div className="Headshot">
      <p><strong>{props.name}</strong></p>
      <img src={props.image} alt={props.alt} />
    </div>
  )
}